<template>
  <q-page>
    <div class="row">
      <div v-if="!$apollo.loading" class="full-width">
        <h2 class="q-mt-sm text-center">{{emailTemplate.name}}</h2>
<!--        <div class="text-h4 text-center">({{emailTemplate.event}})</div>-->
<!--        <h3>Details</h3>-->
        <div class="row q-pa-md">
          <div class="col-6 q-gutter-md q-pr-md">
            <m-edit-item field="name" type="input" graphqlType="EmailTemplate" :id="id" />
            <m-edit-item field="event" type="enum" graphqlType="EmailTemplate" :id="id" :enums="eventEnums"/>
            <m-edit-item field="enabled" type="checkbox" graphqlType="EmailTemplate" :id="id" />
            <m-edit-item field="from" type="input" graphqlType="EmailTemplate" :id="id" />
            <m-edit-item field="to" type="array" graphqlType="EmailTemplate" :id="id" />
            <m-edit-item field="cc" type="array" graphqlType="EmailTemplate" :id="id" />
            <m-edit-item field="bcc" type="array" graphqlType="EmailTemplate" :id="id" />
            <m-edit-item field="testData" type="json" graphqlType="EmailTemplate" :id="id" class="font-monospace" />
            <m-edit-item field="subject" type="input" graphqlType="EmailTemplate" :id="id" />
            <m-edit-item field="html" type="input" input-type="textarea" graphqlType="EmailTemplate" :id="id" class="font-monospace" />
          </div>
          <div class="col-6 q-pl-md">
<!--            <div class="text-h3 q-mt-md">Preview</div>-->
            <q-btn @click="compile" class="q-ma-md">Compile</q-btn>
            <q-btn @click="sendTestEmail" class="q-ma-md">Send Test Email</q-btn>

            <q-layout view="lHh lpr lFf" container style="height: 600px" class="shadow-2 rounded-borders">
              <q-header elevated>
                <q-bar color="blue">
                  <q-icon name="email" />
                  <div>Emails</div>

                  <q-space />

                  <q-btn dense flat icon="minimize" />
                  <q-btn dense flat icon="crop_square" />
                  <q-btn dense flat icon="close" />
                </q-bar>

                <div class="q-pa-sm q-pl-md row items-center">
                  <div class="cursor-pointer non-selectable">
                    File
                    <q-menu>
                      <q-list dense style="min-width: 100px">
                        <q-item clickable v-close-popup>
                          <q-item-section>Open...</q-item-section>
                        </q-item>
                        <q-item clickable v-close-popup>
                          <q-item-section>New</q-item-section>
                        </q-item>

                        <q-separator />

                        <q-item clickable v-close-popup>
                          <q-item-section>Quit</q-item-section>
                        </q-item>
                      </q-list>
                    </q-menu>
                  </div>
                </div>
              </q-header>

              <q-page-container>
                <q-page class="col q-pa-md">
                  <h4 class="q-ma-sm">{{compiled.subject}} <q-badge align="middle" color="grey">Inbox</q-badge></h4>
                  <div class="q-mb-md row">
                    <div class="col-1 text-center">
                      <q-avatar color="blue" text-color="white" class="q-mr-md" icon="person" />
                    </div>
                    <div class="col">
                      From: <b>{{compiled.from}}</b><br/>
                      To: me ({{compiled.to[0]}})<br/><br/>
                    </div>
                  </div>
                  <div class="q-mb-md row">
                    <div class="col-1 text-center">
                    </div>
                    <div class="col">
                      <div v-html="compiled.html"></div>
                    </div>
                  </div>
                </q-page>
              </q-page-container>
            </q-layout>
          </div>
        </div>
      </div>
    </div>
  </q-page>
</template>

<style lang="stylus">
  .font-monospace {
    textarea {
      font-family monospace
    }
  }
  .email-preview {
    -webkit-border-radius: 5px
    -moz-border-radius: 5px
    border-radius: 5px
    border: black solid 1px
  }
</style>

<script>
import gql from 'graphql-tag'
import MEditItem from '../../components/ui/admin/MEditItem'

export default {
  name: 'PageAdminEmailTemplate',
  components: { MEditItem },
  apollo: {
    emailTemplate () {
      return {
        query: gql`
          query emailTemplate ($id: ID!) {
            emailTemplate (id: $id) {
              id
              name
              event
              enabled
              to
              from
              cc
              bcc
              subject
              html
              testData
              updatedAt
              createdAt
            }
          }
        `,
        variables: {
          id: this.id
        },
        async result (result) {
          await new Promise(resolve => setTimeout(resolve, 1000))
          this.compile()
        },
        fetchPolicy: 'network-only'
      }
    }
  },
  computed: {
    id () {
      return this.$route.params.id
    }
  },
  methods: {
    async sendTestEmail () {
      this.$q.dialog({
        html: true,
        title: 'Send Test Email',
        message: `We're about to send a test email to <b>${this.compiled.to.join(', ')}</b>.  Are you sure you want to do this?`,
        ok: 'Send It!',
        cancel: true
      }).onOk(async () => {
        this.$q.loading.show({
          message: '<h4>Sending Your Email!<br/>Hang on...</h4>'
        })
        try {
          await this.$store.$apollo.query({
            query: gql`
              query sendTestEmailTemplate ($id: ID!) {
                sendTestEmailTemplate (id: $id)
              }
            `,
            variables: {
              id: this.id
            },
            fetchPolicy: 'network-only'
          })
          this.$q.loading.hide()
          this.$q.dialog({
            title: 'Check your inbox',
            message: 'Message Sent Successfully!',
            cancel: false
          })
        } catch (ex) {
          this.$q.dialog({
            title: 'Failed To Send Email!',
            message: ex.message,
            cancel: false
          })
        }
      })
    },
    async compile () {
      const result = await this.$store.$apollo.query({
        query: gql`
          query testEmailTemplate ($id: ID!) {
            testEmailTemplate (id: $id) {
              to
              from
              cc
              bcc
              subject
              html
            }
          }
        `,
        variables: {
          id: this.id
        },
        fetchPolicy: 'network-only'
      })
      this.compiled = result.data.testEmailTemplate
    }
  },
  data () {
    return {
      emailTemplate: {},
      compiled: { to: ['not compiled'], from: 'notcompiled', subject: 'Compile Me!', html: '<h2>Not Compiled Yet</h2>' },
      eventEnums: [
        'None',
        'UserPlacesOrder',
        'UserPlacesContainerOrder',
        'UserPlacesRetailOrder',
        'AdminVerifiesOrder',
        'AdminUnVerifiesOrder',
        'AdminVerifiesContainerOrder',
        'AdminUnVerifiesContainerOrder',
        'AdminVerifiesRetailOrder',
        'AdminUnVerifiesRetailOrder',
        'UserRegisters',
        'RetailUserRegisters',
        'AdminVerifiesAccount',
        'PasswordResetRequest',
        'AddStockFromBrandOrder',
      ]
    }
  }
}
</script>
